/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { Sphere3D } from '../../../../mol-math/geometry';
import { BoundaryHelper } from '../../../../mol-math/geometry/boundary-helper';
var tmpSphere = Sphere3D();
var boundaryHelperCoarse = new BoundaryHelper('14');
var boundaryHelperFine = new BoundaryHelper('98');
function getBoundaryHelper(count) {
    return count > 500 ? boundaryHelperCoarse : boundaryHelperFine;
}
export function computeStructureBoundary(s) {
    var units = s.units;
    var boundaryHelper = getBoundaryHelper(units.length);
    boundaryHelper.reset();
    for (var i = 0, _i = units.length; i < _i; i++) {
        var u = units[i];
        var invariantBoundary = u.boundary;
        var o = u.conformation.operator;
        if (o.isIdentity) {
            boundaryHelper.includeSphere(invariantBoundary.sphere);
        }
        else {
            Sphere3D.transform(tmpSphere, invariantBoundary.sphere, o.matrix);
            boundaryHelper.includeSphere(tmpSphere);
        }
    }
    boundaryHelper.finishedIncludeStep();
    for (var i = 0, _i = units.length; i < _i; i++) {
        var u = units[i];
        var invariantBoundary = u.boundary;
        var o = u.conformation.operator;
        if (o.isIdentity) {
            boundaryHelper.radiusSphere(invariantBoundary.sphere);
        }
        else {
            Sphere3D.transform(tmpSphere, invariantBoundary.sphere, o.matrix);
            boundaryHelper.radiusSphere(tmpSphere);
        }
    }
    return { box: boundaryHelper.getBox(), sphere: boundaryHelper.getSphere() };
}
